import ArticleCardSkeleton from './ArticleCardSkeleton'

export default ArticleCardSkeleton
